export default {
  className: '_User',
  fields: [
    'wechatName'
  ],
  action: false
}
